import React from "react";

import { formatInTimeZone } from "date-fns-tz";

import { Event } from "../../../../../models/marine.traffic";
import { EventTypeCode, SplitableWordsEnum } from "../../../../../util/enums";
import {
  ContentItemContainer,
  ContentItemText,
  ContentItemTextBold,
  ContentItemTitle,
} from "./styles";

interface StepperContentItemProps {
  event: Event;
  color: string;
  isAirTracking?: boolean;
}

export const StepperContentItem = ({
  event,
  color,
  isAirTracking = false,
}: StepperContentItemProps) => {
  const wordsToSplit = [SplitableWordsEnum.AT, SplitableWordsEnum.FROM, SplitableWordsEnum.TO];

  const clearDescriptionExtraInfo = (description: string) => {
    let auxDescription = description;

    wordsToSplit.forEach((word) => {
      if (auxDescription.includes(word)) {
        auxDescription = description?.split(` ${word} `)[0];
      }
    });

    return auxDescription;
  };

  const renderVessel = () => {
    const itemByMode = () => {
      if (isAirTracking) {
        return <ContentItemText>{event?.vessel.vesselName}</ContentItemText>;
      }
      return <ContentItemTextBold>{event?.vessel.vesselName}</ContentItemTextBold>;
    };
    switch (event.eventTypeCode) {
      case EventTypeCode.CONTAINER_LOAD_PORT_OF_LOAD:
      case EventTypeCode.CONTAINER_LOAD_TRANSHIPMENT:
      case EventTypeCode.DEPARTED:
      case EventTypeCode.ARRIVAL:
        return itemByMode();

      default:
        return null;
    }

  };

  const renderEventDate = () => {
    if (!event.eventDatetime) return "\u00A0";

    const date = new Date(event.eventDatetime);

    if (Number.isNaN(date.getTime())) return "\u00A0";

    return `${formatInTimeZone(date, "UTC", "dd/MM/yyyy hh:mm aa")} UTC`;
  };

  return (
    <ContentItemContainer>
      <ContentItemTitle color={color}>
        {clearDescriptionExtraInfo(event.eventTypeDescription)}
      </ContentItemTitle>
      <ContentItemText>{renderEventDate()}</ContentItemText>
      {renderVessel()}
    </ContentItemContainer>
  );
};
